"use client";

import { getSelectedFilterKeys } from "@faire/retailer-shared/filters/getFilterOptions";
import { IFilterablePaginatedSection } from "@faire/web-api--source/indigofair/data/IFilterablePaginatedSection";
import cloneDeep from "lodash/cloneDeep";
import { useEffect } from "react";
import * as React from "react";

import { FilterContext } from "@faire/retailer/components/Filters/FilterContext";
import {
  FilterState,
  useCreateFilterStore,
} from "@faire/retailer/components/Filters/FilterStore";
import { useFilterablePaginatedSectionQuery } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Fetching/useFilterablePaginatedSectionQuery";
import { useSDUIFilterablePaginatedSectionState } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Filters/useSDUIFilterablePaginatedSectionState";

export const SDUIFilterStoreProvider: React.FC<{
  filterablePaginatedSection: IFilterablePaginatedSection;
  children: React.ReactNode;
}> = ({ filterablePaginatedSection, children }) => {
  const { setFilterKeys, clearOneIndexedPageNumber } =
    useSDUIFilterablePaginatedSectionState();

  const { isFilterLoading, filtersResponse } =
    useFilterablePaginatedSectionQuery(filterablePaginatedSection);

  const onFilterSelected = (state: FilterState) => {
    const filterKeys = getSelectedFilterKeys(state.filterSections);
    setFilterKeys(() => filterKeys);
    clearOneIndexedPageNumber();
  };

  const filterStore = useCreateFilterStore(
    FilterState.build(),
    onFilterSelected
  );

  useEffect(() => {
    if (filtersResponse?.filter_sections && !isFilterLoading) {
      filterStore.setState((currentState) => ({
        ...currentState,
        filterSections: cloneDeep(filtersResponse.filter_sections),
        isNewFilterSelected: false,
      }));
    }
  }, [isFilterLoading, filtersResponse, filterStore]);

  return (
    <FilterContext.Provider value={filterStore}>
      {children}
    </FilterContext.Provider>
  );
};
